import React, { useState } from "react"
import Svg from "../../shared/_svgs/svg"
import ReactHtmlParser from "react-html-parser"
import Slider from "react-slick"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function AreaCardsContainer({ areaCards, headline, richTextField, enableCarousel }) {
  const windowWidth = useWindowWidth()

  const htmlAreaCards =
    areaCards.length > 0
      ? areaCards.map((card) => {
          return enableCarousel ? (
            <AreaCardAsCarouselItem
              key={card.linkLabel}
              image={card.image}
              linkLabel={card.linkLabel}
              //Epi mixup, URL = linkTarget, Link target = target
              link={card.linkTarget}
              target={card.target}
              description={card.description}
            />
          ) : (
            <AreaCard
              key={card.linkLabel}
              image={card.image}
              linkLabel={card.linkLabel}
              //Epi mixup, URL = linkTarget, Link target = target
              link={card.linkTarget}
              target={card.target}
              description={card.description}
            />
          )
        })
      : undefined

  var settings = {
    dots: windowWidth < 768 ? true : false,
    arrows: windowWidth < 768 ? false : true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipe: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          swipe: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          swipe: true,
          variableWidth: true,
        },
      },
    ],
  }

  return (
    <section className={"area-cards-container"}>
      <div className="w--normal">
        <h2 className="rich-text">{richTextField ? ReactHtmlParser(richTextField) : headline}</h2>
        {enableCarousel ? (
          <div className="show-as-carousel">
            <Slider {...settings}>{htmlAreaCards}</Slider>
          </div>
        ) : (
          <div className="grid">{htmlAreaCards}</div>
        )}
      </div>
    </section>
  )
}

function AreaCard({ link, target, image, linkLabel, description }) {
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  function handleMouseEvent() {
    if (!isFocused) setIsHovered(!isHovered)
  }

  function handleFocusEvent() {
    setIsFocused(!isFocused)
    if (isHovered) setIsHovered(!isHovered)
  }

  return (
    <div className="grid-item">
      <a
        onMouseEnter={() => handleMouseEvent()}
        onMouseLeave={() => handleMouseEvent()}
        onFocus={() => handleFocusEvent()}
        onBlur={() => handleFocusEvent()}
        href={link}
        target={target[0]?.value || "_blank"}
      >
        <img src={image} alt="" />
        <div className="textarea">
          <div className="flex-container">
            <div className="textarea-header">
              <h3 className={isHovered || isFocused ? "is-hovered" : ""}>{linkLabel}</h3>
              <Svg iconName="arrowright-slim" fillColor={"transparent"} stroke={isHovered || isFocused ? "#3a70cc" : "#071143"} />
            </div>
            <div className="maintext">{description}</div>
          </div>
        </div>
      </a>
    </div>
  )
}

function AreaCardAsCarouselItem({ link, target, image, linkLabel, description }) {
  const [isHovered, setIsHovered] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  function handleMouseEvent() {
    if (!isFocused) setIsHovered(!isHovered)
  }

  function handleFocusEvent() {
    setIsFocused(!isFocused)
    if (isHovered) setIsHovered(!isHovered)
  }

  return (
    <a
      onMouseEnter={() => handleMouseEvent()}
      onMouseLeave={() => handleMouseEvent()}
      onFocus={() => handleFocusEvent()}
      onBlur={() => handleFocusEvent()}
      className="grid-item"
      href={link}
      target={target[0]?.value || "_blank"}
    >
      <div className="image-wrapper">
        <img src={image} alt="" />
      </div>
      <div className="textarea">
        <div className="flex-container">
          <div className="textarea-header">
            <h3 className={isHovered || isFocused ? "is-hovered" : ""}>{linkLabel}</h3>
            <Svg iconName="arrowright-slim" fillColor={"transparent"} stroke={isHovered || isFocused ? "#3a70cc" : "#071143"} />
          </div>
          <div className="maintext">{description}</div>
        </div>
      </div>
    </a>
  )
}
